import { Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { IRequest } from 'ngxs-requests-plugin';

import { AuthGetterState } from '../ngxs/auth/auth-getter.state';
import {
  ClearToken,
  LogOut,
  ResendVerificationEmail,
  ResetPassword,
  ResetPasswordConfirm,
  SignIn,
  SignUp,
  UpdatePassword,
  UpdateUser,
  AcceptTerms,
  VerifyEmail
} from '../ngxs/auth/auth.actions';
import {
  AcceptTermsRequestState,
  LogOutRequestState,
  ResendVerificationEmailRequestState,
  ResetPasswordConfirmRequestState,
  ResetPasswordRequestState,
  SignInRequestState,
  SignUpRequestState,
  UpdatePasswordRequestState,
  UpdateUserRequestState,
  VerifyEmailRequestState
} from '../ngxs/auth/auth.state';
import { IProfile, ISignInInput, ISignUpInput, ITokenAcceptance, IUser, IVerifyUser } from '../interfaces/auth.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  @Select(AuthGetterState.getCurrentUser)
  currentUser$: Observable<IUser>;

  @Select(AuthGetterState.getToken)
  token$: Observable<string>;

  @Select(SignInRequestState)
  getSignInRequestState$: Observable<IRequest>;

  @Select(SignUpRequestState)
  getSignUpRequestState$: Observable<IRequest>;

  @Select(VerifyEmailRequestState)
  verifyEmailRequestState$: Observable<IRequest>;

  @Select(ResendVerificationEmailRequestState)
  resendVerificationEmailRequestState$: Observable<IRequest>;

  @Select(ResetPasswordRequestState)
  getResetPasswordRequestState$: Observable<IRequest>;

  @Select(ResetPasswordConfirmRequestState)
  getResetPasswordConfirmRequestState$: Observable<IRequest>;

  @Select(UpdatePasswordRequestState)
  updatePasswordRequestState$: Observable<IRequest>;

  @Select(UpdateUserRequestState)
  updateUserRequestState$: Observable<IRequest>;

  @Select(AcceptTermsRequestState)
  acceptTermsRequestState$: Observable<IRequest>;

  @Select(LogOutRequestState)
  logOutRequestState$: Observable<IRequest>;

  constructor(
    private store: Store,
  ) {
  }

  signIn(data: ISignInInput) {
    this.store.dispatch(new SignIn(data));
  }

  getCurrentUser(): IUser {
    return this.store.selectSnapshot(AuthGetterState.getCurrentUser);
  }

  signUp(data: ISignUpInput) {
    this.store.dispatch(new SignUp(data));
  }

  resendVerificationEmail(username: string) {
    this.store.dispatch(new ResendVerificationEmail(username));
  }

  verifyEmail(data: IVerifyUser) {
    this.store.dispatch(new VerifyEmail(data));
  }

  resetPassword(data: string) {
    this.store.dispatch(new ResetPassword(data));
  }

  resetPasswordConfirm(data: any) {
    this.store.dispatch(new ResetPasswordConfirm(data));
  }

  clearToken() {
    this.store.dispatch(new ClearToken());
  }

  updatePassword(password, newPassword) {
    this.store.dispatch(new UpdatePassword({password, newPassword}));
  }

  updateUser(userData: IProfile) {
    this.store.dispatch(new UpdateUser(userData));
  }

  acceptTerms(data: ITokenAcceptance) {
    this.store.dispatch(new AcceptTerms(data));
  }

  logOut() {
    this.store.dispatch(new LogOut());
  }
}
